import { render, staticRenderFns } from "./editSale.vue?vue&type=template&id=36e70858&scoped=true&"
import script from "./editSale.vue?vue&type=script&lang=js&"
export * from "./editSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e70858",
  null
  
)

export default component.exports